import logo_1 from "./public/logo.svg";
import logo$002Danimated from "./public/logo-animated.svg";

export const logo = logo_1;

export const animatedLogo = logo$002Danimated;

